import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	avatarAlt: {
		id: 'project-settings-apps.issue-type-page.main-header.avatar-icon.avatar-alt',
		defaultMessage: 'Issue type icon',
		description: 'Icon input label',
	},
	avatarAccessibleAlt: {
		id: 'project-settings-apps.issue-type-page.main-header.avatar-icon.avatar-accessible-alt',
		defaultMessage: 'Change issue type icon',
		description: 'Icon input label',
	},
	avatarAriaLabel: {
		id: 'project-settings-apps.issue-type-page.main-header.avatar-icon.avatar-aria-label',
		defaultMessage: 'Change issue type icon - {issueType}',
		description: 'Avatar button aria-label',
	},
	editAvatar: {
		id: 'project-settings-apps.issue-type-page.main-header.avatar-icon.edit-avatar',
		defaultMessage: 'Edit issue type icon',
		description:
			'Icon label. Shows on icon that opens dialog. Allows changing avatar of the currently visible Issue type.',
	},

	errorMessageIssueTypeNameTooShort: {
		id: 'project-settings-apps.issue-type-page.main-header.name-inline-input.too-short-error-name',
		defaultMessage: 'Add a name.',
		description: 'Error displayed when work item, type name is too short.',
	},
	errorMessageIssueTypeNameAlreadyExists: {
		id: 'project-settings-apps.issue-type-page.main-header.name-inline-input.already-exists-error-name',
		defaultMessage: 'Already exists. Try a different name.',
		description: 'Error displayed when name entered is already assigned to another work item type.',
	},
	errorMessageIssueTypeNameTooLong: {
		id: 'project-settings-apps.issue-type-page.main-header.name-inline-input.too-long-error-name',
		defaultMessage: "Name can't exceed {maximumNameLength} characters",
		description: 'Error displayed when work item type name is too long.',
	},
	errorMessageIssueTypeHelpTextTooLong: {
		id: 'project-settings-apps.issue-type-page.main-header.help-text-inline-input.too-long-error-name',
		defaultMessage: "Help text can't exceed {maximumHelpTextLength} characters",
		description: 'Error message when help text is too long.',
	},
	errorMessageIssueTypeDescriptionTooLong: {
		id: 'project-settings-apps.issue-type-page.main-header.description-inline-input.too-long-error-name',
		defaultMessage: "Description can't exceed {maximumDescriptionLength} characters",
		description: 'Error message when description is too long.',
	},
	emailRequestTypeDescription: {
		id: 'project-settings-apps.issue-type-page.main-header.email-request-type-description.description-jsm',
		defaultMessage: 'Request received from your email support channel.',
		description:
			'This is the non-editable description for a Jira Service Management email request type',
	},
});

export const messagesIssueTermRefresh = defineMessages({
	avatarAlt: {
		id: 'project-settings-apps.issue-type-page.main-header.avatar-icon.avatar-alt-issue-term-refresh',
		defaultMessage: 'Work type icon',
		description: 'Icon input label',
	},
	avatarAccessibleAlt: {
		id: 'project-settings-apps.issue-type-page.main-header.avatar-icon.avatar-accessible-alt-issue-term-refresh',
		defaultMessage: 'Change work type icon',
		description: 'Icon input label',
	},
	avatarAriaLabel: {
		id: 'project-settings-apps.issue-type-page.main-header.avatar-icon.avatar-aria-label-issue-term-refresh',
		defaultMessage: 'Change work type icon - {issueType}',
		description: 'Avatar button aria-label',
	},
	editAvatar: {
		id: 'project-settings-apps.issue-type-page.main-header.avatar-icon.edit-avatar-issue-term-refresh',
		defaultMessage: 'Edit work type icon',
		description:
			'Icon label. Shows on icon that opens dialog. Allows changing avatar of the currently visible work type.',
	},
});
